import { useEffect, useState } from "react";
import { request } from "../../network/Request";
import Filter from "../../components/Filter/Filter.js";
import { useTranslation } from "react-i18next";
import { useYear } from "../../context/YearContext.js";
import StatusMessage from "../../components/StatusMessage/StatusMessage.js";

const MatchResultsView = ({
  matchType,
  event,
  gender,
  subTitle,
  topRankCount,
  winners = [],
}) => {
  const { t } = useTranslation();
  const { year } = useYear();
  const [scoreArray, setScoreArray] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);

  const getRankingClass = (index) => {
    return index < parseInt(topRankCount) ? "ranking" : "";
  };

  const shouldDisplayTop = () => {
    // 선택적으로 노란색 행 표시하는 매치타입 (8강, 4강, 3/4위전, 결승)
    let selectedRankingType = ["16", "8", "4", "3", "2"];
    return !selectedRankingType.includes(matchType);
  };

  // 승자 리스트에 있는지 확인
  const getWinnerClass = (winnerNumber) => {
    console.log("winners", winners);
    console.log("winner number", winnerNumber);

    return winners.includes(winnerNumber) ? "ranking" : "";
  };

  // 등수 계산 함수 (상위 16명만 동점 처리, 이후는 순차 등수)
  const calculateRank = (players) => {
    let currentRank = 1;

    return players.map((player, index) => {
      // 16명 이내: 동점 처리
      if (index < 16) {
        if (index > 0 && player.total !== players[index - 1].total) {
          currentRank = index + 1;
        }
      }
      // 16명 이후: 순차 등수
      else {
        currentRank = index + 1;
      }
      return {
        ...player,
        rank: currentRank,
      };
    });
  };

  useEffect(() => {
    setLoading(true);
    request({
      "bk-working": "score-list",
      type: matchType === "PRE" ? matchType : matchType + "-" + event,
      distance: event,
      gender: gender,
      year: year,
    }).then(({ result, response }) => {
      if (result) {
        let scoreArray = response["score_array"];

        // 각 선수 점수, 총점 계산
        scoreArray.forEach((item) => {
          let scoreMap = {};
          let total = 0;
          let turnArray = item.turn_concat.split(",");
          let scoreArr = item.score_concat.split(",");

          for (let i = 0; i < turnArray.length; i++) {
            scoreMap[turnArray[i]] = scoreArr[i];
            total += parseInt(scoreArr[i]);
          }

          item["score_map"] = scoreMap;
          item["total"] = total;
        });

        // 점수 기준 정렬
        const sorted = scoreArray.sort((a, b) => b.total - a.total);

        // 등수 계산
        const withRank = calculateRank(sorted);

        setScoreArray(withRank);
        setFiltered(withRank);
        console.log(withRank);
      } else {
        setScoreArray([]);
        setFiltered([]);
      }
      setLoading(false);
    });
  }, [matchType, event, gender, year]);

  const handleSearch = (filters) => {
    let filtered = [...scoreArray];

    if (filters.country) {
      filtered = filtered.filter((p) => p.country === filters.country);
    }
    if (filters.playerName) {
      filtered = filtered.filter((p) =>
        p.player_name?.toLowerCase().includes(filters.playerName.toLowerCase())
      );
    }

    setFiltered(filtered);
  };

  return (
    <>
      <div className="table-box  box-1 margin-table">
        <div className="table-wrap result-table">
          <div className="table-shadow">
            <div className="table-title-big">
              - {event}m {subTitle} {gender} -
            </div>
            {scoreArray.length !== 0 && <Filter onSearch={handleSearch} />}
            {loading ? (
              <StatusMessage type="loading" />
            ) : scoreArray.length === 0 ? (
              <StatusMessage />
            ) : filtered.length === 0 ? (
              <StatusMessage type="search" />
            ) : (
              <table>
                <colgroup>
                  <col width="5%" />
                  <col width="5%" />
                </colgroup>
                <thead>
                  <tr>
                    <th rowSpan="2">{t("table.rank")}</th>
                    <th rowSpan="2">
                      {t("positions.player")}
                      <br />
                      No.
                    </th>
                    <th rowSpan="2">{t("table.country")}</th>
                    <th rowSpan="2">{t("table.player-name")}</th>
                    <th rowSpan="2">{t("common.gender")}</th>
                    <th colSpan="5">
                      {t("table.event")} ({event}M)
                    </th>
                    <th rowSpan="2">{t("table.total")}</th>
                  </tr>
                  <tr>
                    <th>{t("table.turn")} 1</th>
                    <th>{t("table.turn")} 2</th>
                    <th>{t("table.turn")} 3</th>
                    <th>{t("table.turn")} 4</th>
                    <th>{t("table.turn")} 5</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((player, idx) => (
                    <tr
                      key={idx}
                      className={
                        shouldDisplayTop()
                          ? getRankingClass(idx)
                          : getWinnerClass(player.player_number)
                      }
                    >
                      <td>{player.rank}</td>
                      <td>{player.player_number}</td>
                      <td>{player.country}</td>
                      <td>{player.player_name}</td>
                      <td>{player.gender}</td>
                      <td>{player.score_map[1]}</td>
                      <td>{player.score_map[2]}</td>
                      <td>{player.score_map[3]}</td>
                      <td>{player.score_map[4]}</td>
                      <td>{player.score_map[5]}</td>
                      <td>{player.total}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          <div className="table-gradient"></div>
        </div>
      </div>
    </>
  );
};
export default MatchResultsView;
